import React, { useEffect, useState, useRef } from "react";
import { useHistory, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { WebUrl } from "../../util/Constant";
import { useDispatch } from "react-redux";
import { setBusy, setIdle, setRegisterModal } from "../../redux/AppAction.js";
import { performLogin } from "../../redux/AuthAction.js";
import { useForm } from "react-hook-form";

const CreateAccountSuccessDesktop = (props) => {
    var { t, i18n } = useTranslation();
    var _history = useHistory();
    let _location = useLocation();
    const _dispatch = useDispatch();
    const { handleSubmit } = useForm({
        mode: "onBlur",
    });

    const goToLogin = async (data, e) => {
        _dispatch(setBusy());
        await _dispatch(
            performLogin(props?.username, props?.password)
        );
        _history.replace(WebUrl._URL_DASHBOARD);
        _dispatch(setRegisterModal(false))
        _dispatch(setIdle());
    };

    useEffect(() => {
        if (typeof window.fbq === 'function') {
            window.fbq('track', 'CompleteRegistration', {
            value: 0.00,
            currency: 'USD',
            content_name: 'Registration',
            status: 'success',
            });
        } else {
            console.warn('Facebook Pixel is not available.');
        }
        
        if (window.ttq) {
          const eventId = `reg_${Date.now()}_${Math.random().toString(36).slice(2, 8)}`;
          window.ttq.track('CompleteRegistration', {
            event_id: eventId,
            content_type: 'user',
            description: 'User registration success'
          });
        } else {
            console.warn('Tiktok Pixel is not available.');
        }
    }, []);

    return (
        <>
            <div className="text-center desktop welcome">
                <div className="">
                    <img
                        src={require("../../assets/img/new_icons/checked.png")}
                        className="img-responsive"
                        alt="icon"
                        loading="lazy"
                    />
                </div>
                <h1 className="mt-3">{t("SUCCESS")}!</h1>
                <p className="font16">
                    {t(
                        "YOU_HAVE_CREATED_YOUR_ACCOUNT_YOU_CAN_NOW_START_PLAYING_GAMES_AND_EARN"
                    )}
                    !
                </p>
            </div>
            <div className="width-100-p mt-3">
                <a
                    onClick={() => handleSubmit(goToLogin)()}
                    className="btn btn-custom font20"
                    style={{ cursor: "pointer" }}
                >
                    {t("EXPLORE_THE_APP")}
                </a>
            </div>
        </>
    );
};

export default CreateAccountSuccessDesktop;
